var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      !_vm.permission
        ? _c(
            "v-alert",
            { attrs: { type: "info", dismissable: "", value: "true" } },
            [_vm._v("You do not have permission to edit this page")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.metadata.info
        ? _c(
            "v-alert",
            { attrs: { type: "info", dismissable: "", value: "true" } },
            [_vm._v(_vm._s(_vm.metadata.info))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.metadata.warn
        ? _c(
            "v-alert",
            { attrs: { type: "warn", dismissable: "", value: "true" } },
            [_vm._v(_vm._s(_vm.metadata.warn))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.metadata.error
        ? _c(
            "v-alert",
            { attrs: { type: "error", dismissable: "", value: "true" } },
            [_vm._v(_vm._s(_vm.metadata.error))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { id: "importForm" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "no-print d-none d-md-flex" },
            [
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.downloadTemplate()
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("download")]),
                  _vm._v(" Download Template"),
                ],
                1
              ),
              _vm._v(" "),
              _vm.permission
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-1 ies-coral",
                      on: {
                        click: function ($event) {
                          return _vm.resetForm()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("cancel")]), _vm._v(" Reset")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.listView()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("view_list")]), _vm._v(" List")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.emailLink()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("email")]), _vm._v(" Email")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.reportProblem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("report_problem")]), _vm._v(" Problem")],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "mt-3" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-3" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h2", [_vm._v("Preparing Your Upload")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mt-3" }, [
                          _vm._v(
                            "Click the Download Template button, or create your own spreadsheet containing the data you wish to import.  Please note that only .csv files are supported and the first row must contain the field names.  Not all fields are required.  Please check the data in the file before you upload it.  The automated validation cannot be relied upon to find human error.  Once the data has been imported it may be much harder to find and correct mistakes."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v("The following fields are supported: "),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.formSections, function (section, i) {
                        return _c(
                          "v-col",
                          {
                            key: i,
                            attrs: {
                              cols: "12",
                              sm: "12",
                              md: "12",
                              lg: section.sectionWidth
                                ? section.sectionWidth
                                : 12,
                            },
                          },
                          [
                            _c(
                              "v-card",
                              { staticClass: "ma-3", attrs: { flat: "" } },
                              [
                                _c(
                                  "fieldset",
                                  [
                                    section.sectionName
                                      ? _c("legend", [
                                          _vm._v(_vm._s(section.sectionName)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              type: "info",
                                              dismissable: "",
                                              value: "true",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "Matches will be found using " +
                                                  _vm._s(
                                                    _vm.pageRecord
                                                      .import_match_field
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                "If a match is found then the existing record will be updated.  If no match is found then a new record will be created"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    section.info
                                      ? _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              type: "info",
                                              dismissable: "",
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(section.info))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    section.warn
                                      ? _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              type: "warn",
                                              dismissable: "",
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(section.warn))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    section.error
                                      ? _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              type: "error",
                                              dismissable: "",
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(section.error))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    section.introduction
                                      ? _c("div", [
                                          _vm._v(_vm._s(section.introduction)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      _vm._l(
                                        section.fields,
                                        function (field, k) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: k,
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "4",
                                                lg: "2",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    \t" +
                                                  _vm._s(_vm.fieldInfo(field)) +
                                                  "\n                                \t"
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    section.outroduction
                                      ? _c("div", [
                                          _vm._v(_vm._s(section.outroduction)),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.uxStage == "choose"
            ? _c(
                "v-card",
                { staticClass: "no-print mt-3" },
                [
                  _c("v-card-text", [
                    _c("p", [_vm._v("Please choose a file to import (.csv)")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("input", {
                        attrs: { type: "file", accept: "text/csv" },
                        on: {
                          change: function ($event) {
                            return _vm.fileSelected($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          on: { click: _vm.uploadFile },
                        },
                        [
                          _c("v-icon", [_vm._v("cloud_upload")]),
                          _vm._v(" Upload"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.uxStage == "confirm"
            ? _c(
                "v-card",
                { staticClass: "no-print mt-3" },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-3" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h2", [_vm._v("Analysis")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3" }, [
                              _vm._v(
                                "The following fields were identified in the file:"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "ul",
                              _vm._l(
                                _vm.uploadResponse.identifiedFields,
                                function (identifiedField, key) {
                                  return _c("li", { key: key }, [
                                    _vm._v(
                                      "'" +
                                        _vm._s(identifiedField.fileFieldName) +
                                        "' as " +
                                        _vm._s(
                                          identifiedField.schema.modelName
                                        ) +
                                        " " +
                                        _vm._s(identifiedField.schema.fieldName)
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", [
                              _vm._v(
                                "There are " +
                                  _vm._s(_vm.uploadResponse.numRecordsFound) +
                                  " records in the file"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h2", [_vm._v("Sample")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-3" }, [
                              _vm._v(
                                "Cells in dark grey are not recognised, and will not be imported.  If you expected a field to be imported please check the field heading against the names listed above"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "table",
                              { staticClass: "sample" },
                              _vm._l(
                                _vm.uploadResponse.sample,
                                function (row, rowIndex) {
                                  return _c(
                                    "tr",
                                    { class: { "is-headings": rowIndex == 0 } },
                                    _vm._l(row, function (cell, cellIndex) {
                                      return _c(
                                        "td",
                                        {
                                          class: {
                                            "is-not-relevant":
                                              cell.isRelevant == false,
                                          },
                                        },
                                        [_vm._v(_vm._s(cell.value))]
                                      )
                                    }),
                                    0
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("h2", [_vm._v("Validation")]),
                              _vm._v(" "),
                              _vm.uploadResponse.invalidData.length == 0
                                ? _c("div", { staticClass: "mt-3" }, [
                                    _vm._v("The file passed validation"),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadResponse.invalidData.length > 0
                                ? _c(
                                    "v-alert",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        type: "error",
                                        dismissable: "",
                                        value: "true",
                                      },
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "Validation failed with " +
                                            _vm._s(
                                              _vm.uploadResponse.invalidData
                                                .length
                                            ) +
                                            " problem" +
                                            _vm._s(
                                              _vm.uploadResponse.invalidData
                                                .length === 1
                                                ? ""
                                                : "s"
                                            ) +
                                            ".  Please correct the problems identified below and resubmit the file"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadResponse.invalidData.length > 0
                                ? _c("div", [
                                    _c(
                                      "table",
                                      { staticClass: "sample" },
                                      [
                                        _c(
                                          "tr",
                                          { staticClass: "is-headings" },
                                          [
                                            _c("td", [_vm._v("Record")]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.uploadResponse.sample[0],
                                              function (cell, cellIndex) {
                                                return _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "is-not-relevant":
                                                        cell.isRelevant ==
                                                        false,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(cell.value))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.uploadResponse.invalidData,
                                          function (row, rowIndex) {
                                            return _c(
                                              "tr",
                                              [
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(row.rowIndex + 1)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  row.cells,
                                                  function (cell, cellIndex) {
                                                    return _c(
                                                      "td",
                                                      {
                                                        class: {
                                                          "is-invalid":
                                                            cell.isValid ==
                                                            false,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(cell.value) +
                                                            " "
                                                        ),
                                                        cell.isValid == false
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _vm._v("("),
                                                                _vm._l(
                                                                  cell.errors,
                                                                  function (
                                                                    error,
                                                                    errorIndex
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error.reason
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(")"),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadResponse.invalidData.length == 0
                                ? _c("div", [
                                    _vm._v(
                                      "If this is what you expected to see then you can continue to import the data to the database using the controls below"
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-btn", { on: { click: _vm.resetForm } }, [
                        _vm._v("Upload New File"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: {
                            disabled: _vm.uploadResponse.invalidData.length > 0,
                          },
                          on: { click: _vm.confirmImport },
                        },
                        [_vm._v("Import This Data")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.uxStage == "complete"
            ? _c(
                "v-card",
                { staticClass: "no-print mt-3" },
                [
                  _c("v-card-text", [
                    _vm._v(
                      "\n                    The data file will now be imported.  This may take a few minutes\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-btn", { on: { click: _vm.resetForm } }, [
                        _vm._v("Upload New File"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          on: {
                            click: function ($event) {
                              return _vm.listView()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("view_list")]),
                          _vm._v("View Records"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "no-print d-none d-md-flex" },
            [
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.downloadTemplate()
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("download")]),
                  _vm._v(" Download Template"),
                ],
                1
              ),
              _vm._v(" "),
              _vm.permission
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-1 ies-coral",
                      on: {
                        click: function ($event) {
                          return _vm.resetForm()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("cancel")]), _vm._v(" Reset")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.listView()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("view_list")]), _vm._v(" List")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.emailLink()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("email")]), _vm._v(" Email")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  on: {
                    click: function ($event) {
                      return _vm.reportProblem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("report_problem")]), _vm._v(" Problem")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: parseInt(6000),
            "multi-line": "",
            color: "ies-green",
          },
          model: {
            value: _vm.successSnackbar,
            callback: function ($$v) {
              _vm.successSnackbar = $$v
            },
            expression: "successSnackbar",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "full-height full-width v-align-container text-xs-center",
            },
            [
              _c("h4", { staticClass: "ies-dark-gray--text v-align-div" }, [
                _vm._v("Record Saved"),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: parseInt(6000),
            "multi-line": "",
            color: "ies-coral",
          },
          model: {
            value: _vm.errorSnackbar,
            callback: function ($$v) {
              _vm.errorSnackbar = $$v
            },
            expression: "errorSnackbar",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "full-height full-width v-align-container text-xs-center",
            },
            [
              _c("h4", { staticClass: "ies-dark-gray--text v-align-div" }, [
                _vm._v("Save Failed"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }